import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium drv-mb-1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "form-wrapper row drv-gap-4 drv-py-2" }

import CheckConnection from "../CheckConnection.vue";
import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IBaseBasic,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseBasic',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const isDiasbled = computed<boolean>(() => {
  return props.disable || isLoading.value;
});

const isLoading = ref<boolean>(false);

const emit = __emit;

const EMPTY_MODEL = { type: EAuthTypes.BASIC, username: "", password: "" };

const model = computed<IBaseBasic>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseBasic) {
    emit("update:modelValue", value);
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const passwordModel = computed<string>({
  get() {
    return props.modelValue?.password ?? EMPTY_MODEL.password;
  },
  set(value: string) {
    model.value = { ...model.value, password: value };
  },
});

const currentMethod = computed(() => {
  return props.platform.methods.find(
    (m) => m.authorityType === EAuthTypes.BASIC
  );
});
const url = computed<string | null>(() => {
  return currentMethod.value?.url ?? null;
});
const isConnectionValid = ref<boolean | null>(
  props.modelValue || !currentMethod.value?.check_connection ? true : null
);

const clearConnection = () => {
  emit("update:modelValue", {
    type: EAuthTypes.BASIC,
    username: "",
    password: "",
  } as IBaseBasic);
};

const nameControl = ref<typeof Input | null>(null);
const passwordControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !usernameModel.value ||
    nameControl.value?.hasError ||
    !passwordModel.value ||
    passwordControl.value?.hasError
  );
});
const hasError = computed<boolean>(() => {
  return !isConnectionValid.value || hasFormError.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!
  const _component_d_snackbar = _resolveComponent("d-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_TITLE)), 1),
      _createElementVNode("div", {
        class: "drv-text-body-md drv-color-n700",
        innerHTML: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_SUBTITLE)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_d_input, {
        ref_key: "nameControl",
        ref: nameControl,
        modelValue: usernameModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameModel).value = $event)),
        disable: isDiasbled.value,
        class: "drv-form-control-adaptive",
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_USERNAME_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["modelValue", "disable", "label", "rules"]),
      _createVNode(_component_d_password_input, {
        ref_key: "passwordControl",
        ref: passwordControl,
        class: "drv-form-control-adaptive",
        disable: isDiasbled.value,
        modelValue: passwordModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordModel).value = $event)),
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_PASSWORD_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["disable", "modelValue", "label", "rules"])
    ]),
    (url.value && currentMethod.value?.check_connection)
      ? (_openBlock(), _createBlock(CheckConnection, {
          key: 0,
          class: "drv-py-2",
          modelValue: isConnectionValid.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isConnectionValid).value = $event)),
          loading: isLoading.value,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((isLoading).value = $event)),
          "is-model-fullfiled": !hasFormError.value,
          "platform-type": _ctx.platform.const,
          url: url.value,
          creds: model.value,
          onClear: clearConnection
        }, null, 8, ["modelValue", "loading", "is-model-fullfiled", "platform-type", "url", "creds"]))
      : _createCommentVNode("", true),
    _createVNode(_component_d_snackbar, {
      icon: "triangle-exclamation",
      class: "drv-bg-color-b100 drv-color-b600 drv-my-2",
      message: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_BASIC_INFO)
    }, null, 8, ["message"])
  ]))
}
}

})